 
import React from "react";
import { PersonalInformation } from "./components/PersonalInformation/PersonalInformation";
import { RightPanel } from "../../components/RightPanel";

interface IEditCustomerRightPanelProps {
  open: boolean;
  customer_id: number;
  onClose: () => void;
  onComplete: () => void;
}

export const EditCustomerRightPanel: React.FC<IEditCustomerRightPanelProps> = ({
  open,
  customer_id,
  onClose,
  onComplete,
}) => {



  return (
    <RightPanel
      open={open}
      heading={"Edit Customer"}
      onClose={onClose}
      width="90%"
    >
    
        <PersonalInformation onSaveComplete={onComplete} />
     
    </RightPanel>
  );
};
